import React, { useState } from "react";
import TableAdv from "../../../../../components/Table/TableAdv/TableAdv";
import { dateFormator, formatNumber, mapTableRows } from "../../../../../utils";
import { Button, Chip, StatusTags } from "../../../../../components";
import AccrodianComponent from "./AccrodianComponent";
import { Gender, EmployeeStatus } from "../../../../../assets/data/enumData";
import TableAdvProps from "./TableAdvProps";

export const TableAdvList = () => {
  const [expandedRows, setExpandedRows] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);

  const toggleAccordion = (rowId, accordionType) => {
    setExpandedRows((prev) => {
      if (prev[rowId] === accordionType) {
        const newState = { ...prev };
        delete newState[rowId];
        return newState;
      }
      return { ...prev, [rowId]: accordionType };
    });
  };

  // const statusOptions = [
  //   { label: "Active", value: 1 },
  //   { label: "Inactive", value: 2 },
  //   { label: "Pending", value: 3 },
  // ];

  const allHobbies = [
    "Reading",
    "Traveling",
    "Coding",
    "Photography",
    "Cooking",
    "Gardening",
    "Painting",
    "Playing Guitar",
    "Hiking",
    "Chess",
    "Writing",
    "Gaming",
    "Yoga",
    "Cycling",
    "Dancing",
    "Swimming",
    "Knitting",
    "Bird Watching",
  ];

  // Function to get random hobbies array (1 to 3 hobbies)
  const getRandomHobbies = () => {
    const numberOfHobbies = Math.floor(Math.random() * 3) + 1; // 1 to 3

    const shuffledHobbies = [...allHobbies].sort(() => Math.random() - 0.5);
    return shuffledHobbies.slice(0, numberOfHobbies);
  };

  const rows = Array.from({ length: 400 }, (_, i) => ({
    id: i + 100,
    fullName: {
      firstName: `User ${i + 1}`,
      middleName: `Middle Name ${i + 1}`, // Add middleName to the row data for demonstration purposes
      lastName: `Last Name ${i + 1}`,
    },
    profilePhotoUrl: "",
    username: `user${i + 1}`,
    password: `password${i + 1}`,
    email: `user${i + 1}@example.com`,
    salary: Math.floor(Math.random() * 10000) + 1000,
    joindedDate: new Date(
      Date.now() - Math.floor(Math.random() * 100000000000),
    ).toISOString(), // need like MongoDB stores dates as BSON Date objects
    age: Math.floor(Math.random() * 50) + 18,
    company: `Company ${i + 1}`,
    department: [
      "Engineering",
      "Marketing and sales",
      "Sales",
      "HR",
      "Finance",
    ][Math.floor(Math.random() * 5)],
    status: [1, 2, 3][Math.floor(Math.random() * 3)],
    info: ["", `Some Info for this id ${i + 1}`][Math.floor(Math.random() * 2)],
    countries: [
      "USA",
      "Canada",
      "Australia",
      "India",
      "United Kingdom",
      "Germany",
      "France",
      "Spain",
      "Italy",
      "Brazil",
    ][Math.floor(Math.random() * 10)],
    gender: [1, 2, 3, 4][Math.floor(Math.random() * 4)],

    phone: `+1 (${Math.floor(Math.random() * 1000)}) ${Math.floor(
      Math.random() * 1000,
    )}-${Math.floor(Math.random() * 10000)}`,
    address: `123 Main St, City ${i + 1}, State ${i + 1}, Country ${i + 1}`,
    hobby: getRandomHobbies(), // Now returns an array of 0-5 hobbies
  }));

  const columns = [
    {
      key: "fullName",
      labelKey: "fullName",
      label: "Employee Name",
      render: (row) => {
        return (
          <div className="flex gap-2 items-center">
            {row.fullName.firstName}-{row.fullName.middleName}-
            {row.fullName.lastName}
            <Button
              size="xs-sm"
              onClick={() => toggleAccordion(row.id, "personal")}
              title="test1"
            />
            {/* Button 2 - Work Details */}
            <Button
              size="xs-sm"
              onClick={() => toggleAccordion(row.id, "work")}
              title="test2"
            />
            {/* Button 3 - Contact Info */}
            <Button
              size="xs-sm"
              onClick={() => toggleAccordion(row.id, "contact")}
              title="test3"
            />
          </div>
        );
      },
      width: "w-[450px]", // Using Tailwind class for width
    },
    {
      key: "hobby",
      label: "Hobby",
      render: (row) => {
        //return <div className="whitespace-nowrap">{row.hobby.join(", ")}</div>;
        return (
          <div className="whitespace-nowrap flex gap-1 flex-wrap">
            {row.hobby.map((hobby) => (
              <Chip key={hobby} label={hobby} color="danger" />
            ))}
          </div>
        );
      },
      dataType: "array",
      dataValue: allHobbies,
    },
    {
      key: "joindedDate",
      label: "Joinded Date",
      render: (row) => {
        return (
          <div className="whitespace-nowrap">
            {dateFormator(row.joindedDate)}
          </div>
        );
      },
    },
    {
      key: "email",
      label: "Email Address",
    },
    {
      key: "age",
      label: "Age",
      getRowClass: (row) => {
        // Example conditions for row styling
        if (row.status === "Inactive") {
          return "bg-red-100 !hover:bg-red-200";
        } else if (row.status === "Pending") {
          return "bg-yellow-50 hover:bg-yellow-100";
        } else if (row.age < 50 && row.age > 40) {
          return "bg-blue-50 hover:bg-blue-100 border-l-4 border-blue-500";
        } else if (row.salery > 8000) {
          return "bg-green-50 hover:bg-green-100 font-semibold";
        }
        return ""; // Default case
      },
    },
    {
      key: "department",
      label: "Department",

      render: (row) => {
        return <div className="whitespace-nowrap">{row.department}</div>;
      },
    },
    {
      key: "status",
      label: "Status",
      render: (row) => {
        return (
          <div className="whitespace-nowrap">
            <StatusTags
              size="sm"
              tag={
                EmployeeStatus.find((item) => item.value === row.status)?.label
              }
            />
          </div>
        );
      },
      dataType: "enum",
      dataValue: EmployeeStatus,
    },
    {
      key: "countries",
      label: "Countries",
      // No width specified, will use default flex: 1
    },
    {
      key: "gender",
      label: "Gender",
      render: (row) => {
        return (
          <div>
            {Gender.find((g) => g.value === row.gender)?.label || row.gender}
          </div>
        );
      },

      dataType: "enum",
      dataValue: Gender,

      getCellClass: (row) => {
        if (row.gender === 1) {
          return "bg-green-900 text-white ";
        } else if (row.gender === 2) {
          return "bg-pink-300 ";
        }
        return ""; // Default case
      },
      // hide: true,
    },
    {
      key: "phone",
      label: "Phone",
      render: (row) => {
        return <div className="whitespace-nowrap">{row.phone}</div>;
      },
      // hide: true,
    },
    {
      key: "address",
      label: "Address",
      //width: "w-[350px]",
      render: (row) => {
        return <div className="whitespace-nowrap">{row.address}</div>;
      },
      // hide: true,
    },

    {
      key: "salary",
      label: "Salary",
      total: true,
      totalRender: (totalValue, totals) => {
        //console.log("totals", totals);
        // Example: Add a currency symbol and custom formatting
        return <div className="text-left">$ {formatNumber(totalValue)}</div>;
      },
    },
    {
      key: "salaryNew",
      label: "Salary2",
      width: "150px",
      columnMenu: false,
      // hide: true,
      render: (row) => {
        return <div className="whitespace-nowrap">${row.salary}</div>;
      },
      total: true,
      totalRender: (totalValue, totals) => {
        //console.log("totals", totals);
        // Example: Add a currency symbol and custom formatting
        return <div>Total : $ {formatNumber(totalValue)}</div>;
      },
    },
    {
      key: "",
      label: "Action",
      render: (row) => {
        return (
          <div className="flex gap-2">
            <Button
              type="icon"
              icon={"edit"}
              variant="text"
              size="xs-sm"
              color="info"
              onClick={() => {
                console.log("edit", row);
              }}
            />
            <Button
              type="icon"
              icon={"delete"}
              variant="text"
              size="xs-sm"
              color="danger"
              onClick={() => {
                console.log("delete", row);
              }}
            />
          </div>
        );
      },
    },
  ];
  const mappedRows = mapTableRows(rows, columns);

  // Define all your disable rules in one place
  const disableRules = [
    (row) => row.hobby?.includes("Yoga"),
    (row) => row.age < 20,
    // ... add as many as you need
  ];

  return (
    <div className="">
    <div className="flex-1 flex flex-col overflow-hidden max-h-[50vh]">
      <TableAdv
        columns={columns}
        rows={mappedRows}
        showCheckbox={true}
        showSlNo={true}
        onSelectionChange={setSelectedRows}
        defaultSelectedRows={selectedRows}
        // Disable checkbox for single row
        // disableRowSelection={(row) => row.status === 2}
        // disableRowSelection={(row) => row.hobby?.includes("Reading")}
        // Disable checkbox for multiple rows
        // disableRowSelection={(row) =>
        //   row.fullName.firstName === "User 1" ||
        //   row?.email === "user3@example.com"
        // }
        disableRowSelection={(row) => disableRules.some((rule) => rule(row))}
        //fixedCol={1}
        tableId={"newTableForTesting"}
        /////////////////////////////////////////
        accordion={(row, accordionType) => {
          return <AccrodianComponent data={row} type={accordionType} />;
        }}
        toolbarRight={{
          search: true,
          filter: true,
        }}
        expandedRows={expandedRows}
      />
    </div>
       <TableAdvProps />
    </div>
  );
};
